import { render, staticRenderFns } from "./yhgl.vue?vue&type=template&id=07a726e0&scoped=true&"
import script from "./yhgl.vue?vue&type=script&lang=js&"
export * from "./yhgl.vue?vue&type=script&lang=js&"
import style0 from "./yhgl.vue?vue&type=style&index=0&id=07a726e0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a726e0",
  null
  
)

export default component.exports